import { cn } from "@/lib/utils";
import { KaiChatPanel } from "./KaiChatPanel";
import { KaiHistoryRail } from "./KaiHistoryRail";
import { KaiHistorySidebar } from "./KaiHistorySidebar";
import { kaiChatPageGridClass } from "./kaiPageLayout";

export function KaiChatPage() {
  return (
    <div
      className={cn(
        "flex h-full min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden",
        kaiChatPageGridClass,
        "lg:items-stretch lg:gap-x-3 xl:gap-x-[var(--shell-gap)]",
      )}
    >
      <KaiHistorySidebar className="hidden lg:flex lg:col-start-1 lg:row-start-1" />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col items-center overflow-hidden lg:col-start-2 lg:row-start-1 lg:min-h-0 lg:w-full">
        <KaiHistoryRail />
        <KaiChatPanel />
      </div>
      <div
        aria-hidden
        className="pointer-events-none hidden lg:col-start-3 lg:row-start-1 lg:block"
      />
    </div>
  );
}
